import ApiService from '../../../../../services/ApiService'
import FormatDate from '../../../../../Utils/FormatDate'
import Manage from './components/manage.vue'

export default {
  name: 'recurrentAvoidedCosts',

  components: {
    Manage,
  },

  data() {
    return {
      manageDialog: false,
      manageKey: 0,
      apiService: new ApiService(),
      show: false,
      loading: false,
      items: [],
      currentItem: {},
      units: [],
      departments: [],
      costCenters: [],
      natures: [],
      indices: [],
      unitLoading: false,
      departmentLoading: false,
      costCenterLoading: false,
      natureLoading: false,
      sizes: [10, 30, 90, 180],
      monthlyDialog: false,
      monthlyData: [],
      adjustmentDialog: false,
      adjustmentLoading: false,
      adjustmentData: {
        recurrentCostId: null,
        indexId: null,
        percentage: 0,
        applicationDate: '',
        observations: '',
      },
      filter: {
        unitId: null,
        departmentId: null,
        costCenterId: null,
        natureId: null,
        institutionId: null,
        page: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Natureza',
          align: 'center',
          value: 'avoidedCostNature.nature',
        },
        {
          text: 'Data Início',
          align: 'center',
          value: 'recurrenceStartDate',
        },
        {
          text: 'Data Fim',
          align: 'center',
          value: 'recurrenceEndDate',
        },
        {
          text: 'Valor Mensal',
          align: 'center',
          value: 'cost',
        },
        {
          text: 'Descrição',
          align: 'center',
          value: 'description',
        },
        {
          text: 'Unidades',
          align: 'center',
          value: 'unidades',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department.name',
        },
        {
          text: 'Centro de Custo',
          align: 'center',
          value: 'costCenter.name',
        },
        {
          text: 'Data de criação',
          align: 'center',
          value: 'createdAt',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      monthlyHeaders: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unidade.name',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department.name',
        },
        {
          text: 'Centro de Custo',
          align: 'center',
          value: 'costCenter.name',
        },
        {
          text: 'Natureza',
          align: 'center',
          value: 'avoidedCostNature.nature',
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
        },
        {
          text: 'Valor',
          align: 'center',
          value: 'cost',
        },
        {
          text: 'Descrição',
          align: 'center',
          value: 'description',
        },
        {
          text: 'Data de criação',
          align: 'center',
          value: 'createdAt',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      institution: {},
      deleteDialog: false,
      deleteKey: false,
      user: {},
    }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = this.institution.id

    this.list()
    this.getUnits()
    this.getDepartments()
    this.getCostCenters()
    this.getNatures()
  },

  methods: {
    openManage(item) {
      this.currentItem = item ? JSON.parse(JSON.stringify(item)) : null
      this.manageKey = this.manageKey + 1
      this.manageDialog = true
    },

    formatCurrency(value) {
      if (value != null) {
        return `$ ${value.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      }
      return '0,00'
    },

    uploadDocument(avoidedCost) {
      this.currentAvoidedCost = avoidedCost
      sessionStorage.clear()

      const avoidedCostForUpload = {
        id: avoidedCost.id,
        description: avoidedCost.description,
        cost: avoidedCost.cost,
        type: 'recurrent',
      }
      sessionStorage.setItem(
        'avoidedCost',
        JSON.stringify(avoidedCostForUpload)
      )

      const routeData = this.$router.resolve({ path: '/uploadDocument' })
      window.open(routeData.href, '_blank')
    },

    openDelete(item) {
      this.currentItem = item
      this.deleteKey = !this.deleteKey
      this.deleteDialog = true
    },

    openMonthlyDialog(item) {
      this.currentItem = item
      this.getMonthlyData(item.id)
      this.monthlyDialog = true
    },

    async getMonthlyData(recurrentCostId) {
      this.loading = true
      await this.apiService
        .get(`avoidedCost/unitaryCostsByRecurrent/${recurrentCostId}`)
        .then(async (response) => {
          this.monthlyData = response.content
          for (const item of this.monthlyData) {
            try {
              const docsResponse = await this.apiService.get(
                `avoidedCost/documents/${item.id}`
              )
              this.$set(item, 'uploadDocuments', docsResponse.content || [])
            } catch (error) {
              this.$set(item, 'uploadDocuments', [])
            }
          }

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    uploadDocumentMonthly(unitaryAvoidedCost) {
      sessionStorage.clear()

      const avoidedCostForUpload = {
        id: unitaryAvoidedCost.id,
        description: unitaryAvoidedCost.description,
        cost: unitaryAvoidedCost.cost,
        type: 'unitary',
      }
      sessionStorage.setItem(
        'avoidedCost',
        JSON.stringify(avoidedCostForUpload)
      )

      const routeData = this.$router.resolve({ path: '/uploadDocument' })
      window.open(routeData.href, '_blank')
    },
    remove() {
      this.loading = true
      this.apiService
        .delete(`avoidedCost/delete?id=${this.currentItem.id}`)
        .then(() => {
          this.list()
          this.$toast.success(this.$t('Item removido!'))
          this.loading = false
          this.deleteDialog = false
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async getUnits() {
      this.unitLoading = true
      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institution.id}`)
        .then((response) => {
          this.units = response.content
          this.unitLoading = false
        })
        .catch(() => {
          this.unitLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/list/${this.institution.id}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async getCostCenters() {
      this.costCenterLoading = true
      
      let endpoint
      
      if (!this.filter.unitId) {
        // Se não há unidade selecionada, buscar todos os centros de custo da instituição
        endpoint = `costCenter/listActive/${this.institution.id}`
      } else {
        // Se há unidade selecionada, filtrar por unidade
        endpoint = `costCenter/listActiveByUnidade/${this.institution.id}/${this.filter.unitId}`
      }
      
      await this.apiService
        .get(endpoint)
        .then((response) => {
          this.costCenters = response.content
          this.costCenterLoading = false
        })
        .catch(() => {
          this.costCenterLoading = false
        })
    },

    async getNatures() {
      this.natureLoading = true
      await this.apiService
        .get(`AvoidedCostNature/list/${this.institution.id}`)
        .then((response) => {
          this.natures = response.content
          this.natureLoading = false
        })
        .catch(() => {
          this.natureLoading = false
        })
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    applyFilter() {
      if (this.$refs.form.validate()) {
        this.list()
      }
    },

    reset() {
      this.filter.unitId = null
      this.filter.departmentId = null
      this.filter.costCenterId = null
      this.filter.natureId = null
      this.filter.page = 1
      this.list()
    },

    list() {
      this.loading = true
      this.filter.type = 1

      this.apiService
        .post('avoidedCost/list/paginate', this.filter)
        .then(async (response) => {
          this.loading = false
          this.items = response.content.data

          // Buscar documentos para cada item recorrente
          for (const item of this.items) {
            try {
              const docsResponse = await this.apiService.get(
                `avoidedCost/documents/${item.id}`
              )
              this.$set(item, 'uploadDocuments', docsResponse.content || [])
            } catch (error) {
              this.$set(item, 'uploadDocuments', [])
            }
          }

          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
        .catch(() => {
          this.loading = false
        })
    },
    getDocumentCount(item) {
      return item.uploadDocuments ? item.uploadDocuments.length : 0
    },

    getDocumentButtonColor(item) {
      const count = this.getDocumentCount(item)
      return count > 0 ? '#BBCF20' : '#F5F5F5'
    },
  },

  watch: {
    'filter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.unitId'() {
      // Recarregar centros de custo quando unidade mudar
      this.getCostCenters()
      // Limpar centro de custo selecionado quando unidade mudar
      this.filter.costCenterId = null
    },
  },
}
